export const space = {
  4.5: '1.125rem', // 18px
  6.5: '1.625rem', // 26px
  7.5: '1.875rem', // 30px
  8.5: '2.125rem', // 34px
  11: '2.75rem', // 44px
  13: '3.25rem', // 52px
  15: '3.75rem', // 60px
  16: '4rem', // 64px
  18: '4.25rem', // 68px
  21: '5.25rem', // 84px
  25: '6.25rem', // 100px
  26: '6.125rem', // 98px
  27: '6.75rem', // 108px
  30: '7.5rem', // 120px
  31: '7.75rem', // 124px
  44: '11rem', // 174px
  45: '11.25rem', // 180px
  50: '12.5rem', // 200px
  51: '12.75rem', // 204px
  52: '13rem', // 208px
  55: '13.75rem', // 220px
  57: '14.25rem', // 228px
  61: '15.25rem', // 244px
  62: '15.5rem', // 248px
  62.5: '15.625rem', // 250px
  70: '17.5rem', // 280px
  71: '17.75rem', // 284px
  72: '18rem', // 288px
  82: '22.5rem', // 360px
  84: '21rem', // 336px
  86: '21.5rem', // 344px
  90: '22.5rem', // 360px
  94: '22.75rem', // 364px
  96: '23rem', // 368px
  100: '25.125rem', // 402px
  110: '27.5rem', // 440px
  113: '28.25rem', // 452px
  125: '31.25rem', // 500px
  152: '38rem', // 608px
  310: '77.5rem', // 1240px
  384: '96rem', // 1536px
};

export const sizes = {
  ...space,
};
